import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import {
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  onSnapshot,
} from "firebase/firestore";
import locations from "../spyfallLocations";
import { useNavigate } from "react-router-dom";

const SpyfallLobby = () => {
  const [roomId, setRoomId] = useState("");
  const [joined, setJoined] = useState(false);
  const [players, setPlayers] = useState([]);
  const [isCreator, setIsCreator] = useState(false);
  const [name, setName] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const savedName = localStorage.getItem("spyfallName");
    if (!savedName) {
      alert("Name not set. Redirecting to home.");
      navigate("/");
    } else {
      setName(savedName);
    }
  }, [navigate]);

  const createRoom = async () => {
    const id = Math.random().toString(36).substring(2, 6).toUpperCase();
    const roomRef = doc(db, "rooms", id);

    await setDoc(roomRef, {
      players: [{ name }],
      started: false,
    });

    localStorage.setItem("isCreator", "true");
    setRoomId(id);
    setIsCreator(true);
    setJoined(true);
  };

  const joinRoom = async () => {
    if (!roomId.trim()) return alert("Enter Room ID");

    const formattedRoomId = roomId.trim().toUpperCase();
    const roomRef = doc(db, "rooms", formattedRoomId);
    const roomSnap = await getDoc(roomRef);

    if (!roomSnap.exists()) {
      return alert("Room not found");
    }

    await updateDoc(roomRef, {
      players: arrayUnion({ name }),
    });

    localStorage.setItem("isCreator", "false");
    setRoomId(formattedRoomId);
    setIsCreator(false);
    setJoined(true);
  };

  useEffect(() => {
    if (!joined || !roomId) return;

    const unsub = onSnapshot(doc(db, "rooms", roomId), (docSnap) => {
      const data = docSnap.data();

      if (data?.players) {
        setPlayers(data.players);
      }

      if (data?.started) {
        navigate(`/spyfall/game/${roomId}`);
      }
    });

    return () => unsub();
  }, [joined, roomId, navigate]);

  const handleStartGame = async () => {
    const shuffledLocations = [...locations].sort(() => Math.random() - 0.5);
    const selectedLocations = shuffledLocations.slice(0, 30).sort((a, b) => a.localeCompare(b));
    const randomLocation =
      selectedLocations[Math.floor(Math.random() * selectedLocations.length)];
    const spyIndex = Math.floor(Math.random() * players.length);

    const roles = {};
    players.forEach((p, i) => {
      roles[p.name] = i === spyIndex ? "spy" : "agent";
    });

    await updateDoc(doc(db, "rooms", roomId), {
      started: true,
      locations: selectedLocations,
      location: randomLocation,
      roles,
    });

    navigate(`/spyfall/game/${roomId}`);
  };

  return (
    <div style={styles.container}>
      {!joined ? (
        <>
          <h1>Spyfall Lobby</h1>
          <p>Welcome, <strong>{name}</strong></p>
  
          {/* Row for Create Room */}
          <div style={styles.row}>
            <button style={styles.button} onClick={createRoom}>
              Create Room
            </button>
          </div>
  
          {/* Row for Join Room */}
          <div style={styles.row}>
            <input
              style={{ ...styles.input, width: "5rem" }}
              placeholder="Room ID"
              value={roomId}
              onChange={(e) => setRoomId(e.target.value.toUpperCase())}
            />
            <button style={styles.button} onClick={joinRoom}>
              Join Room
            </button>
          </div>
        </>
      ) : (
        <>
        <h1>Spyfall Lobby</h1>
          <h2>Room: {roomId}</h2>
          <p>Welcome, {name}!</p>
          <h3>Players in room:</h3>
          <ul style={styles.playerList}>
            {players.map((player, index) => (
              <li key={index}>👤 {player.name}</li>
            ))}
          </ul>
          {isCreator && (
            <button style={styles.button} onClick={handleStartGame}>
              Start Game
            </button>
          )}
        </>
      )}
    </div>
  );
};

const styles = {
    container: {
      textAlign: "center",
      marginTop: "4rem",
      fontFamily: "sans-serif",
    },
    row: {
      display: "flex",            // block‑level flex container
      justifyContent: "center",   // center contents horizontally
      alignItems: "center",
      gap: "0.5rem",
      margin: "0.75rem 0",        // space above & below each row
    },
    input: {
      padding: "0.5rem",
      fontSize: "1rem",
    },
    button: {
      padding: "0.6rem 1.2rem",
      fontSize: "1rem",
      border: "none",
      borderRadius: "6px",
      backgroundColor: "#4e6cff",
      color: "#fff",
      cursor: "pointer",
    },
    playerList: {
      listStyle: "none",
      padding: 0,
      marginTop: "1rem",
      fontSize: "1.1rem",
    },
  };
  

export default SpyfallLobby;
